import { useCreateDamageExceptionAction } from '@/api/DamageExceptions';
import { AppPaths } from '@/routes';
import { DamageExceptionActionModel, DamageExceptionJobModel } from '@/types';
import { StyledLink } from '@/ui/globalStyles';
import { timeConverter } from '@/utils/helpers';
import { Alert, Button, Divider, Select, Timeline } from 'antd';
import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface ActionsProps {
  damageExceptionId: number;
  actions: DamageExceptionActionModel[];
  jobs: DamageExceptionJobModel[];
}
export const Actions: FC<ActionsProps> = ({
  damageExceptionId,
  actions,
  jobs,
}) => {
  const navigate = useNavigate();
  const [jobId, setJobId] = useState<number>(-1);
  const [error, setError] = useState<string>();
  const { mutateAsync: createActionAsync, isPending: actionLoading } =
    useCreateDamageExceptionAction(damageExceptionId);

  const defaultOptions = [
    { label: 'Please choose', value: -1 },
    { label: 'New Job', value: 0 },
  ];

  const onAddAction = async () => {
    setError(undefined);
    if (jobId < 0) return;

    const res = await createActionAsync({ damageExceptionId, jobId });
    if (!res.success) {
      setError(res.message.Message);
      return;
    }
    setJobId(-1);
    setError(undefined);
  };

  return (
    <>
      <Divider>Actions</Divider>
      <Timeline
        mode="left"
        items={actions.map((action) => ({
          color: 'orange',
          children: (
            <>
              <p>{`${timeConverter(action.createdAt)} 【${action.createdBy}】link to job:`}</p>
              <div>
                <StyledLink onClick={() => navigate(`/${AppPaths.jobs}`)}>
                  [{action.job.jobId}] {action.job.jobTypeDescription}
                </StyledLink>
              </div>
            </>
          ),
        }))}
      />
      <div className="d-flex gap-2">
        <Select
          className="flex-grow-1"
          value={jobId}
          options={defaultOptions.concat(
            jobs.map((o) => ({
              label: `[${o.jobId}] ${o.jobTypeDescription}`,
              value: o.jobId,
            })),
          )}
          onChange={(e) => setJobId(e)}
        />
        <Button
          type="primary"
          disabled={jobId < 0}
          loading={actionLoading}
          onClick={onAddAction}
        >
          Link Job
        </Button>
      </div>
      {error ? <Alert message={error} type="error" className="my-2" /> : null}
    </>
  );
};
